<template>
  <div>
    <div class="sm:fe-hidden">
      <DesktopContentModal
        @close="$emit('close')"
        :initial-visible-image-index="initialVisibleImageIndex"
        :should-open-image-modal="shouldOpenImageModal"
        :current-visible-review="currentVisibleReview"
        :show-current-review-only="showCurrentReviewOnly"
        :hide-next-nav="hideNextNav"
        :hide-previous-nav="hidePreviousNav"
        @clickPrev="prevReviewIndex"
        @clickNext="nextReviewIndex"
        @prevReview="prevReviewIndex"
        @nextReview="nextReviewIndex"
      />
    </div>

    <div class="lg:fe-hidden">
      <MobileContentModal
        @close="$emit('close')"
        :initial-visible-image-index="initialVisibleImageIndex"
        :should-open-image-modal="shouldOpenImageModal"
        :current-visible-review="currentVisibleReview"
        :show-current-review-only="showCurrentReviewOnly"
        :hide-next-nav="hideNextNav"
        :hide-previous-nav="hidePreviousNav"
        @clickPrev="prevReviewIndex"
        @clickNext="nextReviewIndex"
        @prevReview="prevReviewIndex"
        @nextReview="nextReviewIndex"
      />
    </div>
  </div>
</template>

<script>
  import { mergeDuplicateArrayOfObject } from "@/utils/utils"

  import DesktopContentModal from "./GalleryContentModalComponent/DesktopContentModal.vue"
  import MobileContentModal from "./GalleryContentModalComponent/MobileContentModal.vue"

  export default {
    name: "GalleryContentModal",
    components: {
      DesktopContentModal,
      MobileContentModal,
    },
    inject: ["globalState"],
    props: {
      currentReview: {
        type: Object,
        default: () => ({}),
        required: false,
      },
      // This is to select image in carousel on which user has clicked (in image slider component or review list item etc)
      currentImageId: {
        type: [String, Number],
        default: 0,
      },
      // If Modal is being opened from Image Modal, then we should show back button, and on clicking of it, we should Image Modal back
      shouldOpenImageModal: {
        type: Boolean,
        default: false,
      },
      // This Modal is being opened from Review List Item. So in this case, we don't want any prev/next/back nav functionality
      showCurrentReviewOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        currentVisibleReviewIndex: 0,
        initialVisibleImageIndex: 0,
      }
    },
    mounted() {
      this.findInitialCurrentReviewIndex()
      this.findInitialVisibleImageIndex()
    },
    computed: {
      reviewDataWithImages() {
        // This Modal is being opened from Review List Item. So in this case, we don't want any prev/next/back nav functionality
        // So no need to get the complete review data from global state
        if (this.showCurrentReviewOnly) {
          return
        }
        const reviewData = this.globalState.reviewsWithImages

        return mergeDuplicateArrayOfObject(reviewData)
      },
      currentVisibleReview() {
        if (this.showCurrentReviewOnly) {
          return this.currentReview
        }
        return this.reviewDataWithImages[this.currentVisibleReviewIndex]
      },
      hidePreviousNav() {
        return this.currentVisibleReviewIndex !== 0
      },
      hideNextNav() {
        return (
          this.currentVisibleReviewIndex !==
          this.reviewDataWithImages?.length - 1
        )
      },
    },
    methods: {
      findInitialCurrentReviewIndex() {
        if (this.showCurrentReviewOnly) {
          return
        }

        const findCurrentReviewIndex = this.reviewDataWithImages?.findIndex(
          (review) => review.id === this.currentReview?.id,
        )

        const currentReviewIndex =
          findCurrentReviewIndex === -1 ? 0 : findCurrentReviewIndex

        this.currentVisibleReviewIndex = currentReviewIndex
      },
      findInitialVisibleImageIndex() {
        // No need to check for imageIdIndex if prop (currentImageId) is sent as 0
        if (this.currentImageId === 0) {
          return this.currentImageId
        }

        const imageIdIndex = this.currentVisibleReview?.images?.findIndex(
          (image) => image.id === this.currentImageId,
        )

        this.initialVisibleImageIndex = imageIdIndex === -1 ? 0 : imageIdIndex
      },
      nextReviewIndex() {
        if (
          this.currentVisibleReviewIndex <
          this.reviewDataWithImages.length - 1
        ) {
          this.currentVisibleReviewIndex++
        }
      },
      prevReviewIndex() {
        if (this.currentVisibleReviewIndex > 0) {
          this.currentVisibleReviewIndex--
        }
      },
    },
  }
</script>
